import { useTrackEvent, ANALYTICS_EVENTS } from '@resida/analytics';

const isPreLaunch = import.meta.env.VITE_PRE_LAUNCH === 'true';

export function Hero(): JSX.Element {
  const trackEvent = useTrackEvent();
  return (
    <section
      id="hero"
      data-testid="landing-hero"
      className="py-24 md:py-32 bg-[var(--landing-bg)]"
    >
      <div className="max-w-[var(--landing-container-max)] mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-sm font-medium uppercase tracking-widest text-[var(--landing-accent-text)] mb-4">
          Built for independent landlords
        </p>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[var(--landing-text-primary)] leading-tight max-w-3xl mx-auto">
          One app for your rent, leases, tenants, and expenses.
        </h1>
        <p className="mt-6 text-lg md:text-xl text-[var(--landing-text-muted)] max-w-2xl mx-auto leading-relaxed">
          Resida replaces the spreadsheets, text messages, and email folders
          you use to manage 1 to 20 rental units. It tracks Zelle rent, posts
          your listings to Craigslist and Facebook, lets AI assistants answer
          prospects and coordinate repairs, files the receipts you forward by
          email, and works with Claude and ChatGPT.
        </p>
        <div className="flex justify-center mt-8" hidden={isPreLaunch}>
          <a
            href="/landlord/login"
            data-testid="hero-cta-primary"
            className="inline-flex items-center justify-center min-h-[44px] px-8 py-3 rounded-[var(--landing-radius)] bg-[var(--landing-accent)] hover:bg-[var(--landing-accent-hover)] text-white text-base font-semibold transition-colors shadow-[var(--landing-shadow)]"
            onClick={() => trackEvent(ANALYTICS_EVENTS.LANDING_CTA_CLICKED, { location: 'hero' })}
          >
            Start Free Trial
          </a>
        </div>
      </div>
    </section>
  );
}
